<template>
    <div>
        <div data-test-class="l-reviews-automations-list-item">
            <div class="skill-title color-dark ellipse-text">
                <strong>
                    {{ reviewAutomation.name.slice(0, 80) }}
                    <span v-show="reviewAutomation.name.length > 80">...</span>
                </strong>
            </div>

            <div class="color-grey">
                <span class="r-default-margin">
                    <i class="fal fa-clock r-default-margin-s"></i>
                    <span>{{ $t(`reviews.list.labelNextAutomationOn`) }}</span>
                    {{ reviewAutomation.timing.nextRun | moment("MMM DD") }}
                </span>

                <span class="color-grey">
                    <i class="fal fa-repeat color-grey r-default-margin-s"></i>

                    <span v-show="reviewAutomation.timing.mode === 'once'" class="color-grey">
                        {{
                            $t(`reviews.list.labelModeOnce`, {
                                weeksAfterStart: reviewAutomation.inclusionTrigger.weeksAfterStart,
                            })
                        }}
                    </span>

                    <span v-show="reviewAutomation.timing.mode === 'repeating'" class="color-grey">
                        {{
                            $t(`reviews.list.labelModeRepeating`, {
                                weeksAfterStart: reviewAutomation.inclusionTrigger.weeksAfterStart,
                                repeatsEveryWeeks: reviewAutomation.timing.repeatsEveryWeeks,
                            })
                        }}
                    </span>
                </span>
            </div>

            <div>
                <span
                    class="color-primary clickable r-default-margin"
                    tabindex="0"
                    @click="showReviewAutomation(reviewAutomation._id)"
                    @keyup.enter="showReviewAutomation(reviewAutomation._id)"
                >
                    <i class="fal fa-cog r-default-margin-s"></i>
                    <span>{{ $t(`reviews.list.btnEditAutomation`) }}</span>
                </span>

                <span
                    class="color-primary clickable r-default-margin"
                    tabindex="0"
                    @click="removeWarning = true"
                    @keyup.enter="removeWarning = true"
                >
                    <i class="fal fa-trash r-default-margin-s"></i>
                    <span>{{ $t(`reviews.list.btnDeactivateAutomation`) }}</span>
                </span>
            </div>

            <hr />
        </div>
        <l-confirmation-modal
            v-if="removeWarning"
            :text="$t('reviews.list.deactivateAutomationHelp')"
            @confirm="removeAutomation()"
            @cancel="removeWarning = false"
        />
    </div>
</template>

<script>
import LConfirmationModal from "@/components/LConfirmationModal";

export default {
    components: {
        LConfirmationModal,
    },
    props: {
        reviewAutomation: {
            type: Object,
            required: true,
        },
        removeWarning: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        showReviewAutomation(id) {
            this.$router.push(`/reviews/automations/edit/${id}`);
        },
        removeAutomation() {
            this.removeWarning = false;
            this.$store.dispatch({
                type: "reviews/automations/delete",
                payload: { id: this.reviewAutomation._id },
            });
        },
    },
};
</script>
